import { FiltersTypes } from "@common/types/filters/general";
import { INVOICE_PAGE_FILTER_TABS } from "@components/invoices/invoicePageFilterTabs";
import { ActiveFilter, FilterTabs } from "@components/pageHeader/filters/lib";
import { getLockedActiveFilters } from "../shared/getLockedActiveFilters";

/**
 * Filters that need real workspace data (accounts, customers, catalog items,
 * templates, workspace members) are offered only once a task is scoped to a
 * workspace. Org-level (non client specific) templates keep to the
 * workspace-agnostic subset.
 */
export const ORG_LEVEL_INVOICES_FILTER_TABS: FilterTabs[] = [
    FilterTabs.INVOICE_CREATED_ON,
    FilterTabs.INVOICE_DATE,
    FilterTabs.EXTERNAL_INVOICE_STATUSES,
    FilterTabs.INVOICE_STATUSES,
    FilterTabs.OVERDUE,
    FilterTabs.AMOUNT,
    FilterTabs.SUBSCRIPTION,
    FilterTabs.MATCH_STATUS,
    FilterTabs.INVOICE_TERMS,
];

export const WORKSPACE_INVOICES_FILTER_TABS: FilterTabs[] = [
    FilterTabs.INVOICE_CREATED_ON,
    ...INVOICE_PAGE_FILTER_TABS,
];

const LOCKABLE_FILTER_TABS = new Set<FilterTabs>(
    WORKSPACE_INVOICES_FILTER_TABS,
);

/**
 * Which `originalFilters` keys of a sticky task render as locked pills: the
 * creator-set matching criteria that built the invoice snapshot.
 */
export function getInvoicesLockedActiveFilters(
    originalFilters: FiltersTypes | undefined,
): ActiveFilter[] {
    return getLockedActiveFilters({
        lockableTabs: LOCKABLE_FILTER_TABS,
        originalFilters,
    });
}
